import React from "react";
import { Col, Spinner, Row } from "react-bootstrap";
import { ExclamationCircle, Trash } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { FAILED_DOMAIN_STATUSES } from "../../../../constants";
import {
  useDomainDeleteByApiMutation,
  useDomainRetryMutation,
} from "../../../../graphql/projects.hooks";
import { getDomainStatus } from "../../../../utils";

interface IDomainStatusProps {
  domainUrl: string;
  status: string;
  domainId: number;
  refetchDomainData: () => void;
}

export default function DomainStatus({
  domainId,
  domainUrl,
  status,
  refetchDomainData,
}: IDomainStatusProps) {
  const { t } = useTranslation();
  const { className, text } = getDomainStatus(status);

  const [domainDelete, { loading }] = useDomainDeleteByApiMutation();
  const [domainRetry, { loading: domainRetryLoading }] =
    useDomainRetryMutation();

  const handleDomainDelete = () => {
    domainDelete({
      variables: { domainId },
      onCompleted: () => {
        refetchDomainData();
      },
    });
  };

  const handleTrySetup = () => {
    if (domainRetryLoading) return;
    domainRetry({
      variables: { domainId },
      onCompleted: () => {
        refetchDomainData();
      },
    });
  };

  return (
    <>
      <Row className="text-start align-items-center">
        <Col xs={6}>
          <div className="text-truncate">
            <div className="fs-9 text-gray">{t("folder.domain")}</div>
            <div>{domainUrl}</div>
          </div>
        </Col>
        <Col xs={4}>
          <div className="fs-9 text-gray">{t("payment.Status")}</div>
          <div className={className}>{t(`payment.${text}`)}</div>
        </Col>
        <Col xs="auto" className="ms-auto ps-0">
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Trash
              className="fs-3 cursor-pointer"
              onClick={handleDomainDelete}
            />
          )}
        </Col>
      </Row>
      <hr className="mt-2 mb-3" />
      {FAILED_DOMAIN_STATUSES.includes(status) && (
        <div className="text-start text-danger bg-danger-light p-3 rounded d-flex align-items-center gap-3 mb-4">
          <ExclamationCircle />
          <div className="fs-7">
            <div>
              {t("projects.We noticed that domain wasn't updated correctly.")}
            </div>
            <div>
              {t("projects.Please")}{" "}
              <span
                className="text-danger text-decoration-underline cursor-pointer"
                onClick={handleTrySetup}
              >
                {t("projects.try setup again")}
              </span>
              {domainRetryLoading && (
                <Spinner animation="border" size="sm" className="ms-2" />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
